import 'angular:locale/data:sl';
import 'angular:locale/data:en';
import 'zone.js';
import './projects/mcl-app/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
